/** Which building occupies each tile (0 = none). Used for taps and adjacency, never scanned. */
export class EntityGrid {
  private readonly ids: Int32Array;
  private readonly width: number;

  constructor(width: number, height: number) {
    this.width = width;
    this.ids = new Int32Array(width * height);
  }

  at(tx: number, ty: number): number {
    return this.ids[ty * this.width + tx] ?? 0;
  }

  clear(x: number, y: number, w: number, h: number): void {
    for (let ty = y; ty < y + h; ty++)
      for (let tx = x; tx < x + w; tx++) this.ids[ty * this.width + tx] = 0;
  }

  place(id: number, x: number, y: number, w: number, h: number): void {
    for (let ty = y; ty < y + h; ty++)
      for (let tx = x; tx < x + w; tx++) this.ids[ty * this.width + tx] = id;
  }
}
